import { render } from "./App.vue?vue&type=template&id=3209123f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3209123f&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__